/* Mock notifications — per-user, persisted under `notifications.<user_id>`.
 *
 * Seed lays down a starter list per demo user; mutations (mark-read,
 * mark-all-read, delete) write back. Unread count is derived on read.
 */

import * as store from "@/data/mocks/storage";
import { withLatency } from "./_util";

function keyFor(user_id) {
  return `notifications.${user_id}`;
}

// Anonymous storefront visitors share a demo "anon" inbox so the
// notifications page has content before sign-in. Once logged in,
// reads/writes flip to `notifications.<user_id>`.
function effectiveUserId() {
  const session = store.get("session", null);
  return session ? session.user_id : "anon";
}

function readFor(user_id) {
  return store.get(keyFor(user_id), []) || [];
}

function writeFor(user_id, arr) {
  store.set(keyFor(user_id), arr);
}

export async function list() {
  const arr = readFor(effectiveUserId())
    .slice()
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return withLatency(arr);
}

export async function unreadCount() {
  const arr = readFor(effectiveUserId());
  return withLatency(arr.filter((n) => !n.read).length);
}

export async function markRead(id) {
  const uid = effectiveUserId();
  const arr = readFor(uid).map((n) => (n.id === id ? { ...n, read: true } : n));
  writeFor(uid, arr);
  return withLatency({ ok: true });
}

export async function markAllRead() {
  const uid = effectiveUserId();
  const arr = readFor(uid).map((n) => ({ ...n, read: true }));
  writeFor(uid, arr);
  return withLatency({ ok: true, marked: arr.length });
}

export async function deleteOne(id) {
  const uid = effectiveUserId();
  const arr = readFor(uid).filter((n) => n.id !== id);
  writeFor(uid, arr);
  return withLatency({ ok: true });
}
